import Vue from "vue";
import axios from "axios";
import store from "../store.js";
import $router from "../router.js";
import { Notification } from "element-ui";

export async function httpHelper(service, method, endpoint, body, headers, options = {}) {
	const serviceUrl = service === "RUNTIME" ? process.env.VUE_APP_RUNTIME_ENDPOINT : process.env.VUE_APP_API_ENDPOINT;
	let apiResponse;
	if (!headers) {
		headers = {
			"Content-Type": "application/json",
		};
	}
	let queryString = "?";
	if (method === "GET") {
		for (let key in body) {
			queryString = queryString + `${key}=${body[key]}&`;
		}
	}
	Vue.$cookies.get("accessToken") ? (headers.Authorization = "Bearer " + Vue.$cookies.get("accessToken")) : null;
	await axios({
		method: method,
		url: queryString ? `${serviceUrl}/${endpoint}${queryString}` : `${serviceUrl}/${endpoint}`,
		headers: headers,
		data: body || {},
		...options,
	})
		.then((response) => {
			apiResponse = { response: response.data, status: response.status };
		})
		.catch((error) => {
			if (
				error?.response?.status === 401 &&
				endpoint !== "security/login" &&
				endpoint !== "security/resendOtp" &&
				endpoint !== "security/login2FA" &&
				endpoint !== "security/createOrganisation" &&
				endpoint !== "security/verifyEmail" &&
				endpoint !== "security/approveUserAccount" &&
				!endpoint.includes("security/executePasswordReset")
			) {
				store._actions.logOutMETHOD[0]();
				$router.push("/").catch(() => {
					return;
				});
				Notification({
					title: "Warning",
					message: "Please log in.",
					type: "warning",
					duration: 2000,
				});
				apiResponse = { error: error, response: error.response, status: error.response?.status };
			} else {
				apiResponse = { error: error, response: error.response, status: error.response?.status };
			}
		});
	return apiResponse;
}
